export default __webpack_public_path__ + "static/media/AC_2.7d2fcb84.jpg";